.checkboxContainer {
  display: flex;
  align-items: center;
  margin-left: 0.5em;
}

.checkboxContainer input {
  cursor: pointer;
  width: 21px;
  height: 21px;
  flex-shrink: 0;
}

.checkboxContainer input:focus {
  outline: 2px solid var(--blue);
  offset: 2px;
}

.requiredText {
  font-size: 0.9em;
  color: var(--darkSilver);
  margin-left: 0.2em;
}
